import(/* webpackMode: "eager" */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\app\\home-service\\clientComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\core\\Popup\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\core\\RunningText\\index.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\core\\ServiceSlider\\ServiceSlider.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\core\\Whatsapp\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\layouts\\Galleries\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\layouts\\Jumbotron\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\layouts\\Navbar\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\ui\\label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectTrigger","SelectValue","SelectContent","SelectGroup","SelectLabel"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\components\\ui\\select.tsx");
